const saveScrollPosition = (to, from, next) => {
    to.meta.position = { x: window.scrollX, y: window.scrollY };
    next();
};

export default saveScrollPosition;
